"use strict";

angular.module("vendor")
.directive("rebroadcastResetListing", function() {
    return {
        restrict: "A",
        link: function(scope, element, attrs) {
            scope.$on("resetListing", function(){
                scope.$broadcast("doResetListing");
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/model-management/rebroadcast-reset-listing.directive.js
// module id = 829
// module chunks = 0